import type { DbClient } from '@fintree/supabase/db-client'
import { defaultDbClient } from '@fintree/supabase/db-client'
import { phonesWithActiveStudents } from '../internal/activeStudents'
import type { EnrollmentRow, ExtensionRow } from './dto'

export async function listEnrollments(
  phone?: string,
  client: DbClient = defaultDbClient
): Promise<EnrollmentRow[]> {
  if (phone) {
    const active = await phonesWithActiveStudents([phone], client)
    if (!active.has(phone)) return []
  }

  let query = client
    .from('enrollments')
    .select('*')
    .is('deleted_at', null)
    .order('created_at', { ascending: false })
    .limit(100)
  if (phone) query = query.eq('phone', phone)
  const { data, error } = await query
  if (error) throw error

  const rows = data ?? []
  if (!phone && rows.length) {
    const active = await phonesWithActiveStudents(rows.map((row) => row.phone), client)
    return rows.filter((row) => active.has(row.phone))
  }
  return rows
}

export async function getEnrollmentHistory(
  phone: string,
  client: DbClient = defaultDbClient
): Promise<EnrollmentRow[]> {
  const active = await phonesWithActiveStudents([phone], client)
  if (!active.has(phone)) return []

  const { data, error } = await client
    .from('enrollments')
    .select('*')
    .eq('phone', phone)
    .is('deleted_at', null)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data ?? []
}

export async function listExtensions(
  phone?: string,
  client: DbClient = defaultDbClient
): Promise<ExtensionRow[]> {
  if (phone) {
    const active = await phonesWithActiveStudents([phone], client)
    if (!active.has(phone)) return []
  }

  let query = client
    .from('extensions')
    .select('*')
    .is('deleted_at', null)
    .order('created_at', { ascending: false })
    .limit(100)
  if (phone) query = query.eq('phone', phone)
  const { data, error } = await query
  if (error) throw error

  const rows = data ?? []
  if (!phone && rows.length) {
    const active = await phonesWithActiveStudents(rows.map((row) => row.phone), client)
    return rows.filter((row) => active.has(row.phone))
  }
  return rows
}

export async function getExtensionHistory(
  phone: string,
  client: DbClient = defaultDbClient
): Promise<ExtensionRow[]> {
  const active = await phonesWithActiveStudents([phone], client)
  if (!active.has(phone)) return []

  const { data, error } = await client
    .from('extensions')
    .select('*')
    .eq('phone', phone)
    .is('deleted_at', null)
    .order('created_at', { ascending: false })

  if (error) throw error
  return data ?? []
}
